(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siha-home"]) return;
  try {
    
(function(){
  var root = document.getElementById('siha-root');
  if (!root) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = root.querySelectorAll('.reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function(el){ el.classList.add('is-visible'); });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .05 });
    els.forEach(function(el){ io.observe(el); });
  }

  var header = document.getElementById('sihaHeader');
  var onScroll = function(){ header.setAttribute('data-elevated', window.scrollY > 8 ? 'true' : 'false'); };
  onScroll(); window.addEventListener('scroll', onScroll, { passive: true });

  var menuBtn = document.getElementById('sihaMenuBtn');
  var mobileMenu = document.getElementById('sihaMobileMenu');
  menuBtn.addEventListener('click', function(){
    var open = menuBtn.getAttribute('aria-expanded') === 'true';
    menuBtn.setAttribute('aria-expanded', String(!open));
    mobileMenu.hidden = open;
  });
  mobileMenu.addEventListener('click', function(e){ if (e.target.closest('a')) menuBtn.click(); });

  root.querySelectorAll('.bot-card').forEach(function(card){
    card.addEventListener('click', function(){
      var open = card.getAttribute('aria-expanded') === 'true';
      card.setAttribute('aria-expanded', String(!open));
    });
  });

  root.querySelectorAll('.accordion-trigger').forEach(function(trig){
    trig.addEventListener('click', function(){
      var panel = document.getElementById(trig.getAttribute('aria-controls'));
      var open = trig.getAttribute('aria-expanded') === 'true';
      trig.setAttribute('aria-expanded', String(!open));
      panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
    });
  });

  var galleryMain = document.getElementById('sihaGalleryMain');
  root.querySelectorAll('.gallery-thumbs button').forEach(function(btn){
    btn.addEventListener('click', function(){
      root.querySelectorAll('.gallery-thumbs button').forEach(function(b){ b.setAttribute('aria-current','false'); });
      btn.setAttribute('aria-current','true');
      if (galleryMain) galleryMain.src = btn.getAttribute('data-full');
    });
  });

  var addBtn = document.getElementById('sihaAddToCart');
  var currentVariantId = addBtn ? addBtn.getAttribute('data-variant-id') : null;
  var priceMain = document.getElementById('sihaPriceMain');
  var addLabel = document.getElementById('sihaAddToCartLabel');

  root.querySelectorAll('.variant-pill').forEach(function(pill){
    pill.addEventListener('click', function(){
      root.querySelectorAll('.variant-pill').forEach(function(p){ p.setAttribute('aria-pressed','false'); });
      pill.setAttribute('aria-pressed','true');
      currentVariantId = pill.getAttribute('data-variant-id');
      var price = pill.getAttribute('data-price');
      if (priceMain) priceMain.textContent = price;
      if (addLabel) addLabel.textContent = 'Add to Cart — ' + price;
      if (addBtn) addBtn.setAttribute('data-variant-id', currentVariantId);
      var img = pill.getAttribute('data-image');
      if (img && galleryMain) galleryMain.src = img;
    });
  });

  root.querySelectorAll('.purchase-toggle button').forEach(function(btn){
    btn.addEventListener('click', function(){
      root.querySelectorAll('.purchase-toggle button').forEach(function(b){ b.setAttribute('aria-pressed','false'); });
      btn.setAttribute('aria-pressed','true');
      var note = document.getElementById('sihaPurchaseNote');
      note.innerHTML = btn.getAttribute('data-purchase') === 'sub'
        ? '<span class="placeholder-tag">Coming soon</span> Subscriptions require a subscriptions app — not yet connected. Your order will be placed as one-time for now.'
        : '';
    });
  });

  var qty = 1;
  var qtyOut = document.getElementById('sihaQtyOut');
  var qtyMinus = document.getElementById('sihaQtyMinus');
  var qtyPlus = document.getElementById('sihaQtyPlus');
  if (qtyMinus) qtyMinus.addEventListener('click', function(){ if (qty>1){ qty--; qtyOut.textContent = qty; }});
  if (qtyPlus) qtyPlus.addEventListener('click', function(){ if (qty<20){ qty++; qtyOut.textContent = qty; }});

  var FREE_SHIP_CENTS = parseInt(root.dataset.freeShipCents, 10) || 300000;
  var cartCountEl = document.getElementById('sihaCartCount');
  var cartItemsEl = document.getElementById('sihaCartItems');
  var cartFoot = document.getElementById('sihaCartFoot');
  var shipFill = document.getElementById('sihaShipFill');
  var shipMsg = document.getElementById('sihaShipMsg');
  var cartSubtotal = document.getElementById('sihaCartSubtotal');

  function moneyFmt(cents){
    return (cents/100).toLocaleString(undefined, { style: 'currency', currency: root.dataset.currency, currencyDisplay: 'narrowSymbol' });
  }

  function renderCart(cart){
    cartCountEl.textContent = cart.item_count;
    if (!cart.items.length) {
      cartItemsEl.innerHTML = '<p class="cart-empty">Your cart is empty — add ' + root.dataset.productName + ' to get started.</p>';
      cartFoot.hidden = true;
      shipFill.style.width = '0%';
      shipMsg.textContent = 'Add ' + moneyFmt(FREE_SHIP_CENTS) + ' more for free express shipping';
      return;
    }
    cartFoot.hidden = false;
    cartSubtotal.textContent = moneyFmt(cart.total_price);
    var pct = Math.min(100, (cart.total_price / FREE_SHIP_CENTS) * 100);
    shipFill.style.width = pct + '%';
    shipMsg.innerHTML = cart.total_price >= FREE_SHIP_CENTS
      ? '<b>You\'ve unlocked free express shipping</b>'
      : 'Add <b>' + moneyFmt(FREE_SHIP_CENTS - cart.total_price) + '</b> more for free express shipping';

    cartItemsEl.innerHTML = cart.items.map(function(item, idx){
      return '<div class="cart-line">' +
        '<img src="' + (item.image || '') + '&width=140" alt="">' +
        '<div class="cart-line-info">' +
          '<div class="name">' + item.product_title + '</div>' +
          '<div class="variant">' + item.variant_title + ' &middot; Qty ' + item.quantity + '</div>' +
          '<div class="cart-line-foot"><span>' + moneyFmt(item.final_line_price) + '</span>' +
          '<button class="cart-line-remove" data-line="' + (idx+1) + '">Remove</button></div>' +
        '</div>' +
      '</div>';
    }).join('');

    cartItemsEl.querySelectorAll('.cart-line-remove').forEach(function(b){
      b.addEventListener('click', function(){
        fetch(root.dataset.cartChangeUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(b.getAttribute('data-line'),10), quantity: 0 })
        }).then(function(r){ return r.json(); }).then(renderCart);
      });
    });
  }

  function fetchCart(){ fetch(root.dataset.cartUrl).then(function(r){ return r.json(); }).then(renderCart); }

  function openCart(){
    document.getElementById('sihaCartDrawer').classList.add('is-open');
    document.getElementById('sihaCartBackdrop').classList.add('is-open');
    document.getElementById('sihaCartDrawer').setAttribute('aria-hidden','false');
  }
  function closeCart(){
    document.getElementById('sihaCartDrawer').classList.remove('is-open');
    document.getElementById('sihaCartBackdrop').classList.remove('is-open');
    document.getElementById('sihaCartDrawer').setAttribute('aria-hidden','true');
  }
  document.getElementById('sihaCartBtn').addEventListener('click', function(){ fetchCart(); openCart(); });
  document.getElementById('sihaCartClose').addEventListener('click', closeCart);
  document.getElementById('sihaCartBackdrop').addEventListener('click', closeCart);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeCart(); });

  if (addBtn) {
    addBtn.addEventListener('click', function(){
      addBtn.disabled = true;
      fetch(root.dataset.cartAddUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: currentVariantId, quantity: qty })
      }).then(function(r){ return r.json(); }).then(function(){
        addBtn.disabled = false;
        fetchCart();
        openCart();
      }).catch(function(err){ addBtn.disabled = false; console.error('SIHA add-to-cart failed:', err); });
    });
  }

  fetchCart();
})();

  } catch(e) { console.error(e); }
})();
})();
